import { useEffect, useState } from "react";
import { InputOTP, InputOTPGroup, InputOTPSlot } from "./input-otp";
import { Button } from "./button";
import { Loader2 } from "lucide-react";
import { useWidgetColor } from "@/hooks/useWidgetColor";

type TType = {
  loading: boolean;
  error: string | undefined;
};

type VerifyType = TType & {
  fn: (otp: string) => Promise<boolean>;
};

type ResendType = TType & {
  fn: () => Promise<boolean>;
};

export const ReuseCustomOTP = ({
  verify,
  resend,
}: {
  verify: VerifyType;
  resend: ResendType;
}) => {
  const [otp, setOtp] = useState("");
  const widgetColor = useWidgetColor();
  const [timeLeft, setTimeLeft] = useState(60);

  useEffect(() => {
    if (timeLeft === 0) return;
    const timerID = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timerID);
  }, [timeLeft]);

  return (
    <div>
      <InputOTP maxLength={6} value={otp} onChange={(e) => setOtp(e)}>
        <InputOTPGroup className="w-full flex justify-between space-x-2">
          {Array.from({ length: 6 })
            .fill("6")
            .map((_, idx) => {
              return <InputOTPSlot key={idx} index={idx} />;
            })}
        </InputOTPGroup>
      </InputOTP>

      <p className="flex flex-col lg:flex-row items-center justify-center space-x-2 text-center text-base text-[#99A6AB] lg:text-[18px] mt-5">
        <span className="text-base">Didn&apos;t get the code?</span>{" "}
        {timeLeft > 0 && (
          <span className="text-base font-medium">
            Resend Code ({timeLeft}s)
          </span>
        )}
        {timeLeft === 0 && (
          <div>
            {resend.loading ? (
              <Loader2 className="animate-spin text-primary ml-2" />
            ) : (
              <span
                style={{ color: widgetColor }}
                onClick={async () => {
                  const response = await resend.fn();
                  if (response) {
                    setTimeLeft(60);
                    setOtp("");
                  }
                }}
                className=" text-base font-medium underline cursor-pointer"
              >
                Resend Code
              </span>
            )}
            {resend?.error && (
              <p className="text-sm text-red-500 text-center">
                {resend?.error}
              </p>
            )}
          </div>
        )}
      </p>

      <div className="mt-5 space-y-2">
        <Button
          type="button"
          disabled={verify.loading}
          onClick={() => verify.fn(otp)}
          loading={verify.loading}
          className="w-full"
        >
          Verify
        </Button>
        {verify?.error && (
          <p className="text-sm text-red-500 text-center">{verify?.error}</p>
        )}
      </div>
    </div>
  );
};
